import { render, staticRenderFns } from "./regionalCenterUser.vue?vue&type=template&id=5af23a68&"
import script from "./regionalCenterUser.vue?vue&type=script&lang=js&"
export * from "./regionalCenterUser.vue?vue&type=script&lang=js&"
import style0 from "./regionalCenterUser.vue?vue&type=style&index=0&id=5af23a68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports